import { BrowserModule } from '@angular/platform-browser';
import { NgModule, Injector } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { Error404Component } from './error404/error404.component';
import { SharedModulesModule } from './shared-modules/shared-modules.module';
import { HttpClientModule } from '@angular/common/http';
import { AtpMergeParamsAndQueryParamsResolver, setAppInjector, AtpLowerCaseUrlSerializer } from './atp-core/atp-core';
import { UrlSerializer } from '@angular/router';
import { HttpService } from './services/http.service';
import { HttpErrorsService } from './services/http-errors.service';
import { AtpHttpService } from './atp-core/services/atp-http.service';
import { AtpHttpErrorsService } from './atp-core/services/atp-http-errors.service';
import { AuthService } from './services/auth.service';
import { MatNativeDateModule } from '@angular/material/core';
import { CommonModule } from '@angular/common';
import { SignalrService } from './services/signalr.service';
import { AtpAuthGuard } from './atp-core/guards/atp-auth.guard';
import { AtpAnonimusGuard } from './atp-core/guards/atp-anonimus.guard';
import { AuthComponent } from './auth/auth.component';
import { AtpNotificationsModule } from './atp-core/atp-notifications/atp-notifications.module';
import { NavMenuComponent } from './components/nav-menu/nav-menu.component';
import { PasswordRecoveryComponent } from './password-recovery/password-recovery.component';
import { DevService } from './services/dev.service';
import { AtpSettingsComponent } from './atp-core/components/atp-settings/atp-settings.component';
import {CookieSnackbarComponent} from "./components/cookie-snackbar/cookie-snackbar.component";

@NgModule({
  declarations: [
    AppComponent,
    Error404Component,
    AuthComponent,
    NavMenuComponent,
    PasswordRecoveryComponent,
    AtpSettingsComponent,
    CookieSnackbarComponent,
  ],
  imports: [
    CommonModule,
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    SharedModulesModule,
    HttpClientModule,
    MatNativeDateModule,
    AtpNotificationsModule
  ],
  providers: [
    AtpAuthGuard,
    AtpAnonimusGuard,
    { provide: UrlSerializer, useClass: AtpLowerCaseUrlSerializer },
    { provide: AtpHttpService, useClass: HttpService },
    { provide: AtpHttpErrorsService, useClass: HttpErrorsService },
    AtpMergeParamsAndQueryParamsResolver,

    AuthService,
    SignalrService,
    DevService,
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor(injector: Injector) {
    setAppInjector(injector);
  }
}
